import React from "react";
import PropTypes from "prop-types";
import * as Table from "reactabular-table";
import { injectIntl, intlShape } from "react-intl";

import { genUnitValueFormatter } from "../tabellen/Tabellen";
import { genComponentFormatterLong } from "../model/util/Components";

const Energieverbrauch = props => {
	if ((props.energy === undefined) || (props.energy === [] || props.energy.length === 0))
		return <span/>;
	else
		return (
			<div>
				<Table.Provider columns={[{
					property: "cindex",
					cell: { formatters: [ genComponentFormatterLong(props.compressors, props.intl) ] },
					header: {
						label: props.intl.formatMessage({ id: "Component" })
					}
				}, {
					property: "energy_offload",
					cell: { formatters: [ genUnitValueFormatter("energy", props.units, props.intl, true) ]},
					header: {
						label: props.intl.formatMessage({ id: "No-load" })
					}
				}, {
					property: "energy_onload",
					cell: { formatters: [ genUnitValueFormatter("energy", props.units, props.intl, true) ]},
					header: {
						label: props.intl.formatMessage({ id: "Load" })
					}
				}, {
					property: "energy_total",
					cell: { formatters: [ genUnitValueFormatter("energy", props.units, props.intl, true) ]},
					header: {
						label: props.intl.formatMessage({ id: "Total"})
					}
				}]}>
					<Table.Header />
					<Table.Body rows={props.energy} rowKey="cindex" />
				</Table.Provider>
				<Table.Provider columns={[{
					property: "cindex",
					cell: { formatters: [ genComponentFormatterLong(props.compressors, props.intl) ] },
					header: {
						label: props.intl.formatMessage({ id: "Component" })
					}
				}, {
					property: "kosten_currency",
					cell: { formatters: [ genUnitValueFormatter("currency", props.units, props.intl, true) ]},
					header: {
						label: props.intl.formatMessage({ id: "Cost" })
					}
				}, {
					property: "co2_aequivalent_kg",
					cell: { formatters: [ genUnitValueFormatter("mass", props.units, props.intl, true) ]},
					header: {
						label: props.intl.formatMessage({ id: "CO² equivalent" })
					}
				}]}>
					<Table.Header />
					<Table.Body rows={props.costs} rowKey="cindex" />
				</Table.Provider>
			</div>);
};

Energieverbrauch.propTypes = {
	energy: PropTypes.arrayOf(PropTypes.object).isRequired,
	costs: PropTypes.arrayOf(PropTypes.object).isRequired,
	compressors: PropTypes.arrayOf(PropTypes.object).isRequired,
	units: PropTypes.object.isRequired,
	intl: intlShape.isRequired
};

export default injectIntl(Energieverbrauch);
